import { DateTime } from 'luxon';
import { getSelectedLocale } from './Localization';

export const formatLocalTime = (date: Date, format?: string): string =>
  DateTime.fromJSDate(date)
    .setLocale(getSelectedLocale())
    .toFormat(format ?? 'd MMMM yyyy HH:mm');

export const formatLocalDate = (date: Date): string =>
  formatLocalTime(date, 'dd LLLL yyyy');
